import { Action } from '@ngrx/store';
import * as ApplicationDataCaptureResponse from './../actions/response-applicationDataCapture.actions';

export type Actions = ApplicationDataCaptureResponse.Actions;


export function ResponseApplicationModalReducer(state = [], action: ApplicationDataCaptureResponse.Actions) {
    switch (action.type) {
        case ApplicationDataCaptureResponse.ADD_RESPONSE_APPLICATIONDATA:
            return [...state, action.payload];

        // Add this case:
        case ApplicationDataCaptureResponse.REMOVE_RESPONSE_APPLICATIONDATA:
            state = [];
            return state;

        default:
            return state;
    }
}
